import * as actionTypes from './actionTypes';

import axios from '../../axios-orders';


export const registrationSuccess= (driverData)=>{
    
    return {
      
      type: actionTypes.REGISTRATION_SUCCESS,
      driverData: driverData
  };  
}

export const registrationFail= (error)=>{
    
    return {
      
      type: actionTypes.REGISTRATION_FAIL,
      error: error
  };  
}

export const registrationStart=()=>{
    
    return{
        
        type: actionTypes.REGISTRATION_START
    }
}

export const sendDriverInfo=(driverData, token)=>{
 

 return dispatch=>{
        
         dispatch(registrationStart());
     
        axios.post('/drivers.json//?auth=' +token, driverData).then(response=>{
        
        dispatch(registrationSuccess(driverData));
            
    }).catch(error=>{
        
        dispatch(registrationFail(error));
    })
     
 }  
};

//?auth=' +token


export const registrationInit=()=>{
    
    return{
        
        type: actionTypes.REGISTRATION_INIT
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/reg.js